import { css } from '@emotion/react';
import { getScreen } from '@/styles/media-query';
import { withPrefix } from 'gatsby';

export type PageHeaderProps = {
  className?: string;
  en: React.ReactNode;
  title: React.ReactNode;
  subTitle?: string;
  readText?: React.ReactNode;
  children?: React.ReactNode;
};

export const PageHeader: React.FC<PageHeaderProps> = ({
  className,
  en,
  title,
  subTitle,
  readText,
  children,
}) => {
  return (
    <header
      className={className}
      css={css`
        padding: 32px 30px 28px;
        position: relative;
        z-index: 1;

        @media ${getScreen('pc')} {
          padding: 64px 30px 60px;
        }

        @media ${getScreen('pc-menu')} {
          padding: 160px 30px 60px;
        }
      `}
    >
      {/* 背景装飾・丸み */}
      <div
        css={css`
          pointer-events: none;
          position: absolute;
          z-index: -1;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          overflow: hidden;
          mask: url(${withPrefix('/images/section-round-reverse-sp.png')}) center bottom/100%
              64px no-repeat,
            linear-gradient(0deg, #000 0%, #000 100%) center bottom 63px/100%
              100% no-repeat;

          @media ${getScreen('pc')} {
            background: ;
            mask: url(${withPrefix('/images/section-round-reverse-pc.png')}) center bottom/100%
                192px no-repeat,
              linear-gradient(0deg, #000 0%, #000 100%) center bottom 191px/100%
                100% no-repeat;
          }
        `}
      >
        <div
          css={css`
            pointer-events: none;
            position: absolute;
            z-index: -1;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: linear-gradient(
              257deg,
              #f0fcfb 0%,
              #f8fffe 49%,
              #ffffff 100%
            );
            mix-blend-mode: multiply;

            @media ${getScreen('pc')} {
              background: linear-gradient(
                266deg,
                #f0fcfb 0%,
                #f8fffe 49%,
                #ffffff 100%
              );
            }
          `}
        />
        <div
          css={css`
            pointer-events: none;
            position: absolute;
            z-index: -1;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: linear-gradient(
              260deg,
              #f0fcfb 0%,
              #f8fffe 49%,
              #ffffff 100%
            );
            mix-blend-mode: multiply;

            @media ${getScreen('pc')} {
              background: linear-gradient(
                264deg,
                #f0fcfb 0%,
                #f8fffe 49%,
                #ffffff 100%
              );
            }
          `}
        />
        {/* 背景ロゴ */}
        <div
          css={css`
            pointer-events: none;
            position: absolute;
            z-index: -1;
            top: -276px;
            left: calc(50% + 90px);
            width: calc(50% - 90px);

            @media ${getScreen('pc', '未満')} {
              display: none;
            }
          `}
        >
          <img src={withPrefix('/images/header-bg.png')} width="752" height="738" alt="" />
        </div>
      </div>
      <p
        css={css`
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          font: normal normal bold 12px/15px 'din-2014-narrow', sans-serif;
          letter-spacing: 2.16px;
          color: #00b3a7;
          gap: 8px;
          margin-bottom: 8px;

          @media ${getScreen('pc')} {
            font: normal normal bold 14px/18px 'din-2014-narrow', sans-serif;
            letter-spacing: 2.52px;
            gap: 12px;
            margin-bottom: 15px;
          }

          &::after {
            content: '';
            display: block;
            width: 62px;
            height: 1px;
            background: #00b3a7;

            @media ${getScreen('pc')} {
              width: 76px;
            }
          }
        `}
      >
        {en}
      </p>
      <h1
        css={css`
          text-align: center;
          font: normal normal bold 20px/28px 'Noto Sans JP', sans-serif;
          letter-spacing: 0.8px;
          color: #00b3a7;

          @media ${getScreen('pc')} {
            font: normal normal bold 30px/44px 'Noto Sans JP', sans-serif;
            letter-spacing: 1.2px;
          }
        `}
      >
        {title}
      </h1>
      {subTitle && (
        <p
          css={css`
            margin-top: 12px;
            text-align: center;
            font: normal normal bold 14px/20px 'Noto Sans JP', sans-serif;
            letter-spacing: 0.97px;
            color: #00b3a7;

            @media ${getScreen('pc')} {
              margin-top: 16px;
              font: normal normal bold 18px/26px 'Noto Sans JP', sans-serif;
              letter-spacing: 1.24px;
            }
          `}
        >
          {subTitle}
        </p>
      )}
      {children}
      {readText && (
        <p
          css={css`
            text-align: center;
            font: normal normal normal 14px/20px 'Noto Sans JP', sans-serif;
            letter-spacing: 0px;
            color: #5a5b6a;
            margin-top: 16px;

            @media ${getScreen('pc')} {
              font: normal normal normal 14px/26px 'Noto Sans JP', sans-serif;
              letter-spacing: 0.56px;
              margin-top: 24px;
            }
          `}
        >
          {readText}
        </p>
      )}
    </header>
  );
};
